import React from 'react';
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  SvgIcon,
  Typography,
} from '@mui/material';
import { PlusIcon } from 'components/SVG';
import { SparkButton } from 'sharedComponents/UI';
import { useDialog } from 'hooks/common/useDialog';
import CreateMemoryModal from './Modals/CreateMemoryModal';
import MemoryContent from './MemoryNewContent';
import SparkMainAppSearchFilters from 'components/common/SparkMainAppSearchFilters/V2';
import { useSparkSearchContext } from 'hooks/common/useSparkSearchContextV2';
import { usePopover } from 'hooks/common';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import MemorySearchFilters from 'components/CreateSpark/Modals/SelectStepTypeModal/MemorySearchFilters';

function MemoryContainer() {
  const { filter, handleItemTypeChange, handleQueryChange } =
    useSparkSearchContext();

  const { open, openPopover, closePopover, anchorEl } = usePopover();

  const {
    open: isAddMemoryDialogOpen,
    openDialog: openAddMemoryDialog,
    closeDialog: closeAddMemoryDialog,
  } = useDialog();

  const memoryTypeDropdownOptions = [
    { label: 'My Sources', value: 'mySources' },
    { label: 'Workspace Sources', value: 'workspaceSources' },
    { label: 'My Favourites', value: 'myFavouritesSources' },
  ];

  return (
    <Grid container justifyContent='center'>
      <Grid item alignItems='center' xs={12}>
        <Box display='flex' align-items='center' justifyContent='space-between'>
          <Typography
            variant='h4'
            sx={{
              fontFamily: 'Mont-semibold',
            }}
          >
            Knowledge
          </Typography>
          <SparkButton
            variant='contained'
            startIcon={
              <SvgIcon
                sx={{
                  '& path': {
                    fill: 'white',
                  },
                  stroke: 'white',
                }}
              >
                <PlusIcon color='white' width='22' height='22' />
              </SvgIcon>
            }
            onClick={openAddMemoryDialog}
          >
            <Typography
              sx={{
                fontSize: '18px',
                textTransform: 'capitalize',
              }}
            >
              Create Source
            </Typography>
          </SparkButton>
        </Box>
      </Grid>

      <Grid display={'flex'} gap={2} width={'100%'} marginY={3}>
        <MemorySearchFilters
          memoryTypeDropdownOptions={memoryTypeDropdownOptions}
        />
      </Grid>
      <MemoryContent />
      {isAddMemoryDialogOpen && (
        <CreateMemoryModal
          open={isAddMemoryDialogOpen}
          onClose={closeAddMemoryDialog}
        />
      )}
    </Grid>
  );
}

export default MemoryContainer;
